export const TOGGLE_FLYOUT = "TOGGLE_FLYOUT";
export type TOGGLE_FLYOUT = typeof TOGGLE_FLYOUT;

export const TOGGLE_GPC = "TOGGLE_GPC";
export type TOGGLE_GPC = typeof TOGGLE_GPC;

export const OPEN_SUB_MODAL = "OPEN_SUB_MODAL";
export type OPEN_SUB_MODAL = typeof OPEN_SUB_MODAL;

export const CLOSE_SUB_MODAL = "CLOSE_SUB_MODAL";
export type CLOSE_SUB_MODAL = typeof CLOSE_SUB_MODAL;

export const SET_SIGN_IN = "SET_SIGN_IN";
export type SET_SIGN_IN = typeof SET_SIGN_IN;
